import { Component, OnInit, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClozeTestStyleModel, GerInfoComponent } from 'gast-onset-ng2';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-ger-info',
  templateUrl: './ger-info.component.html',
  styleUrls: ['./ger-info.component.scss'],
  standalone: true,
  imports: [CommonModule, GerInfoComponent]
})
export class GerInfoPageComponent implements OnInit {
  readonly #deviceService = inject(DeviceDetectorService);

  mobileMode = signal(false);
  cTestLogo = signal('');
  clozeTestStyleModel = signal<ClozeTestStyleModel>({} as ClozeTestStyleModel);
  cTestButtonColor = signal('');
  lang = signal('de');

  ngOnInit() {
    // detect mobile
    this.mobileMode.set(this.#deviceService.isMobile());
    this.clozeTestStyleModel.set(this.#generateClozeTestStyle());
    this.cTestButtonColor.set(this.clozeTestStyleModel()!.onsetColor);
    // set logo and button color
    this.cTestLogo.set('onset-assets/img/onset_logo.png');
  }

  #generateClozeTestStyle(): ClozeTestStyleModel {
    // TODO config
    const model = {} as ClozeTestStyleModel;
    model.siteBackground = '#ffffff';
    model.exerciseBackground = '#EEF3F8';
    model.frameColor = '#92aac1';
    model.barColor = '#b3c9de';
    model.specialCharacterListColor = '#b3c9de';
    model.specialChcaracterTextColor = '#000000';
    model.exerciseTextColor = '#000000';
    model.buttonsColor = '#fa9463';
    model.testdafColor = '#57a7d6';
    model.onsetColor = '#a5d8db';
    model.duoColor = '#ed6a5b';
    model.testasColor = '#fac075';
    model.font = 'arial, helvetica, sans-serif';
    model.fontSize = '11pt';
    model.displayLogo = true;
    model.cTestInformationUrl = 'https://www.onset.de/onset/durchfuehrung/zusatz.jsp';
    return model;
  }
}
